var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "job-card",
      class: _vm.status
        .toLowerCase()
        .trim()
        .replace(/ /g, "-"),
      on: {
        click: function($event) {
          return _vm.showJobDetail(_vm.jobId)
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "inner" },
        [
          _vm.priority.toLowerCase().trim() == "urgent"
            ? _c(
                "span",
                { staticClass: "urgent-flag" },
                [
                  _c("font-awesome-icon", {
                    staticClass: "icon",
                    attrs: { icon: "flag", fixedWidth: "" }
                  }),
                  _vm._v("Urgent\n    ")
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mb-2" },
            [
              _c("b-col", [
                _c("h4", { staticClass: "mb-0" }, [_vm._v(_vm._s(_vm.labRef))])
              ]),
              _vm._v(" "),
              _c("b-col", [
                _c("div", { staticClass: "job-purchase-order text-right" }, [
                  _vm._v(_vm._s(_vm.clientRef))
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", [
                _c("div", { staticClass: "job-samples text-left" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.sampleCount) + "\n          "
                  ),
                  _vm.sampleCount <= 1
                    ? _c("span", [_vm._v("Sample")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.sampleCount > 1
                    ? _c("span", [_vm._v("Samples")])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("b-col", [
                _c("div", { staticClass: "job-dates text-right" }, [
                  _vm._v(
                    _vm._s(_vm._f("moment")(_vm.receivedDate, "D MMM YYYY"))
                  )
                ])
              ])
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2412d026", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2412d026","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/JobCard.vue
// module id = IiSs
// module chunks = 1